import core from "./core.js";
import setup from "./setup.js";
import axios from 'axios'

core.setup = setup.setup

let base = core


axios.interceptors.request.use(async (config) => {
    // Do something before request is sent
    
    if (window && window.ProveAnything.Auth && window.ProveAnything.Auth.User){
        const token = await window.ProveAnything.Auth.User.getIdToken()
        config.headers.Authorization = `Bearer ${token}`
    }
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });



if (window){
    if (!window.ProveAnything){
        window.ProveAnything = {}
    }
    window.ProveAnything.Core = core
    window.ProveAnything.setup = setup.setup
    base = window.ProveAnything
}


export default base;